module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0013_014.ac8c0621.png";